import React, { useEffect, useRef } from 'react';

import { useLocation } from '@reach/router';
import { withPrefix } from 'gatsby';

import type { DocSearchHit } from '../../../../types';
import { sanitizeSlug } from '../../../../utils/sanitizeSlug';
import { InternalLink } from '../../InternalLink';

import * as classes from './style.module.scss';

interface Props {
  hit: DocSearchHit;
}

export const Hit: React.FC<Props> = ({ hit, children }) => {
  const abortPrefetch = useRef(null);
  const { pathname, search } = useLocation();
  const { slug, anchor } = hit;

  const to = sanitizeSlug(`${slug}${anchor}`);

  // note: only displaying a link will not trigger a prefetch event do it manually instead
  useEffect(() => {
    const currentPath = pathname + search;

    // Prefetch is used to speed up next navigations. When you use it on the current navigation,
    // there could be a race-condition where Chrome uses the stale data instead of waiting for the network to complete
    // @ts-ignore
    if (currentPath !== to && ___loader) {
      // @ts-ignore
      abortPrefetch.current = ___loader.enqueue(withPrefix(to));
    }
    // todo: There is no function to abort a prefetch. Was only added to later Gatsby versions.
  }, [to, pathname, search, abortPrefetch]);

  return (
    <InternalLink className={classes.root} to={to}>
      {children}
    </InternalLink>
  );
};
